import { StarIcon } from '@newcore/icons';
import { Tooltip } from '@newcore/ui/tooltips';
import { useToggleFavorite } from '@/hooks/use-toggle-favorite';

interface FavoriteButtonProps {
  applicationId: string;
  isFavorite: boolean;
}

export const FavoriteButton = ({
  applicationId,
  isFavorite,
}: FavoriteButtonProps) => {
  const toggleFavorite = useToggleFavorite();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    toggleFavorite.mutate({ applicationId, isFavorite: !isFavorite });
  };

  const label = isFavorite ? 'Remove from favorites' : 'Add to favorites';

  return (
    <Tooltip content={label}>
      <button
        type='button'
        aria-label={label}
        aria-pressed={isFavorite}
        className={`flex h-5 w-5 items-center justify-center rounded-full transition-colors ${
          isFavorite
            ? 'bg-utility-orange-400 hover:bg-utility-orange-500'
            : 'bg-utility-gray-300 hover:bg-utility-orange-400'
        }`}
        onClick={handleClick}
      >
        <StarIcon className='h-3 w-3 fill-white' strokeWidth={0} />
      </button>
    </Tooltip>
  );
};
